import React from "react";
import "./style.css";

function Title() {
  return <h1 className="title">Employee Directory</h1>;
}

export default Title;